import { useQuery } from '@tanstack/react-query';
import { configurationProvider } from '@printdeal/configuration';
import { ServiceFactory } from '../../services/ServiceFactory';

import { ChatAvailability } from '../../components/widgets/chat/chatTypes';

/**
 *  Hook for fetching the chat availability
 */
const useChatAvailability = (isChatEnabled = true): ChatAvailability => {
  const { data } = useQuery({
    queryKey: ['chat'],
    queryFn: async () => {
      try {
        const baseUrl = configurationProvider.getValue('BASE_URL');
        const primaryService = ServiceFactory.createHelpCenterService(
          `${baseUrl}/api/help-center/v1`,
        );
        return await primaryService.getChatAvailability();
      } catch {
        const fallbackService = ServiceFactory.createHelpCenterService();
        // eslint-disable-next-line @typescript-eslint/return-await
        return await fallbackService.getChatAvailability();
      }
    },
    retry: 1, // Retry the query once in case of an error
    gcTime: 0, // Set cacheTime to 0 to disable caching for errors
    enabled: isChatEnabled,
  });

  return {
    online: Boolean(data?.online),
    averageWaitingTime: parseInt(data?.averageWaitingTime || '0', 10),
  };
};

export default useChatAvailability;
